import SweetAlertsContainer from "../../Componant/BonusUI/SweetAlerts";

const SweetAlerts = () => {
  return (
    <div className="page-body">
      <SweetAlertsContainer />
    </div>
  );
};

export default SweetAlerts;
